const emptyObj = {};

export const getPlannerMembersInfo = (state) =>
  (state.users && state.users.me && state.users.me.team_planner_members) ||
  emptyObj;
